/* 
On loading single loadForm302Route for transfer process
params passportId : id of the reciept
*/
export const loadForm302Route = (passportId, callback) => {
  return dispatch => {
    dispatch({
      type: 'FETCH_FORM302_STEPS',
      passportId,
      callback
    })
  }
}


/* 
On loading single loadForm302Route for transfer process
params passportId : reciept data
*/
export const loadForm302RouteSuccess = (data) => {
  return dispatch => {
    dispatch({
      type: 'FETCH_FORM302_STEPS_SUCCESS',
      data
    })
  }
}


/* 
On loadForm302Route fail action
params passportId : reciept data
*/
export const loadForm302RouteFail = (passportId, errors) => {
  return dispatch => {
    dispatch({
      type: 'FETCH_FORM302_STEPS_FAIL',
      passportId,
      errors
    })
  }
}


/*
On adding Form302Route step data request for a product route
params data : step data
*/
export const addForm302RouteStep = (data) => {
  return dispatch => {
    dispatch({
      type: 'ADD_FORM302_STEP',
      data
    })
  }
}


/*
On success of adding Form302Route data request for a product route
params data : step data
*/
export const addForm302RouteStepSuccess = (step) => {
  return dispatch => {
    dispatch({
      type: 'ADD_FORM302_STEP_SUCCESS',
      step
    })
  }
}


/*
On failing of adding Form302Route step data request for a product route
params errors    : errors
*/
export const addForm302RouteStepFail = (errors) => {
  return dispatch => {
    dispatch({
      type: 'ADD_FORM302_STEP_FAIL',
      errors
    })
  }
}

/*
On deleting step data
params id : step id
*/
export const deleteForm302RouteStep = (id, identifier) => {
  return dispatch => {
    dispatch({
      type: 'DELETE_FORM302_ROUTE_STEP',
      id,
      identifier
    })
  }
}


/*
On success of deleting step data
*/
export const deleteForm302RouteStepSuccess = (id) => {
  return dispatch => {
    dispatch({
      type: 'DELETE_FORM302_ROUTE_STEP_SUCCESS',
      id
    })
  }
}


/*
On failing of deleting step data
params errors    : errors
*/
export const deleteForm302RouteStepFail = (id, errors) => {
  return dispatch => {
    dispatch({
      type: 'DELETE_FORM302_ROUTE_STEP_FAIL',
      id,
      errors
    })
  }
}


/* 
On publishing a product route
params identifier : identifier of product route
*/
export const publishForm302Route = (identifier) => {
  return dispatch => {
    dispatch({
      type: 'PUBLISH_FORM302_ROUTE',
      identifier
    })
  }
}


/* 
On succes of publishing a product route
params identifier : of product route
*/
export const publishForm302RouteSuccess = (identifier) => {
  return dispatch => {
    dispatch({
      type: 'PUBLISH_FORM302_ROUTE_SUCCESS',
      identifier
    })
  }
}


/* 
On failure of publishing a product route
params identifier : of product route
     errors    : errors
*/
export const publishForm302RouteFail = (identifier, errors) => {
  return dispatch => {
    dispatch({
      type: 'PUBLISH_FORM302_ROUTE_FAIL',
      identifier,
      errors
    })
  }
}


/* 
On updating step data request for a product route
params data : step data
*/
export const updateForm302StepCords = (id, data) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_STEP_CORDS',
      id,
      data
    })
  }
}


/* 
On success of updating step data request for a product route
params data : step data
*/
export const updateForm302StepCordsSuccess = (id, step) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_STEP_CORDS_SUCCESS',
      step,
      id
    })
  }
}


/* 
On failing of updating step data request for a product route
params errors    : errors
*/
export const updateForm302StepCordsFail = (id, errors) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_STEP_CORDS_FAIL',
      id,
      errors
    })
  }
}

/* 
On panning zooming a product route
params identifier : identifier of product route
*/
export const updateForm302RoutePanZoom = (identifier, data) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_PAN_ZOOM',
      identifier,
      data
    })
  }
}


/* 
On succes of panning zooming a product route
params identifier : of product route
*/
export const updateForm302RoutePanZoomSuccess = (identifier) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_PAN_ZOOM_SUCCESS',
      identifier
    })
  }
}


/* 
On failure of panning zooming a product route
params identifier : of product route
   errors    : errors
*/
export const updateForm302RoutePanZoomFail = (identifier, errors) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_PAN_ZOOM_FAIL',
      identifier,
      errors
    })
  }
}

export const fetchCategories = () => {
  return dispatch => {
    dispatch({
      type: 'FETCH_CATEGORIES'
    })
  }
}

export const fetchCategoriesSuccess = (data) => {
  return dispatch => {
    dispatch({
      type: 'FETCH_CATEGORIES_SUCCESS',
      data
    })
  }
}

export const fetchCategoriesFail = (errors) => {
  return dispatch => {
    dispatch({
      type: 'FETCH_CATEGORIES_FAIL',
      errors
    })
  }
}

export const updateForm302Route = (id, data, callback, path, reloadIdentifier) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_ROUTE',
      id,
      data,
      callback,
      path,
      reloadIdentifier
    })
  }
}

// Optimistic update: merge display data into routeInfo so UI shows saved values before PATCH completes
export const setForm302RouteOptimistic = (displayData) => {
  return dispatch => {
    dispatch({
      type: 'FORM302_ROUTE_OPTIMISTIC_UPDATE',
      displayData
    })
  }
}

export const updateForm302RouteSuccess = (data) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_ROUTE_SUCCESS',
      data
    })
  }
}

export const updateForm302RouteFail = (errors) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_ROUTE_FAIL',
      errors
    })
  }
}

export const updateForm302DevRoute = (sscc, data, callback) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_DEV_ROUTE',
      sscc,
      data,
      callback
    })
  }
}

export const updateForm302DevRouteSuccess = (data) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_DEV_ROUTE_SUCCESS',
      data
    })
  }
}

export const updateForm302DevRouteFail = (errors) => {
  return dispatch => {
    dispatch({
      type: 'UPDATE_FORM302_DEV_ROUTE_FAIL',
      errors
    })
  }
}